// Console environment ("mode") store — the Stripe test/live toggle.
//
// Module-level so the axios interceptor (which isn't a React component) can read the
// current mode synchronously on every request. Persisted to localStorage so the
// choice survives a reload. React components read/set it via useEnv().
//
// Safety: anything that isn't exactly "prod" resolves to preprod — prod is an
// explicit opt-in, matching the backend's X-Env handling.
const KEY = "vu_console_env";

export const ENVS = ["preprod", "prod"];

const normalize = (v) => (v === "prod" ? "prod" : "preprod");

let current = normalize(localStorage.getItem(KEY));

export function getEnv() {
  return current;
}

export function setEnv(env) {
  current = normalize(env);
  localStorage.setItem(KEY, current);
  return current;
}
